import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { Box, Line, SidebarModal } from '@campaignhub/suit-theme'
import PageContext from '@contexts/pageContext'

import AssetDetails from './components/AssetDetails'
import ProofingNotes from './components/ProofingNotes'
import SidebarList from './components/SidebarList'
import VSIRStatus from './components/VSIRStatus'

const AssetSettingsModal = (props) => {
  const { callbacks, disableAnimation, disableOverlay, modalKey, showModal } = props

  const { serviceJob } = useContext(PageContext)

  return (
    <SidebarModal
      callbacks={callbacks}
      disableAnimation={disableAnimation}
      disableOverlay={disableOverlay}
      modalKey={modalKey}
      showModal={showModal}
      size="small"
    >
      <SidebarModal.Header callbacks={callbacks} title="Asset" titleSecondLine="Settings" />
      <SidebarModal.Content boxProps={{ padding: 0 }} hasFooter={false}>
        <Box flexDirection="column">
          <AssetDetails />
          <Line margin={0} />

          <Box flexDirection="column" padding="large">
            <ProofingNotes />
          </Box>
          <Line margin={0} />

          {serviceJob?.service?.name === 'Photo Retouching - CT Supplied' && (
            <>
              <Box flexDirection="column" padding="large">
                <VSIRStatus />
              </Box>
              <Line margin={0} />
            </>
          )}

          <SidebarList />
          <Line margin={0} />
        </Box>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

AssetSettingsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  disableAnimation: PropTypes.bool,
  disableOverlay: PropTypes.bool,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

AssetSettingsModal.defaultProps = {
  modalKey: 'AssetSettingsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <AssetSettingsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
